// Mock data for Gateway Inc. website

export const mockData = {
  organization: {
    name: "Gateway Inc.",
    tagline: "Come On In, The Door Is Open to a Brighter Future",
    mission: "Gateway Inc. empowers individuals and families in achieving economic self-sufficiency by providing faith-based and coordinated social supports that restore lives, create pathways of stability, and build generational legacy.",
    phone: "(555) 123-4567",
    email: "info@gatewayinc.org",
    address: "123 Hope Street, Community City, ST 12345",
    taxId: "12-3456789"
  },

  heroImages: [
    "https://images.unsplash.com/photo-1597698110516-023a0489ac0c?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?crop=entropy&cs=srgb&fm=jpg&q=85",
    "https://images.unsplash.com/photo-1597524678053-5e6fef52d8a3?crop=entropy&cs=srgb&fm=jpg&q=85"
  ],

  stats: [
    { number: "12,480+", label: "Meals Served Last Year" },
    { number: "10", label: "Families Housed" },
    { number: "2,300+", label: "Children Educated" },
    { number: "12", label: "Veterans Supported" }
  ],

  programs: [
    {
      id: 1,
      title: "Food Market",
      icon: "utensils",
      image: "https://images.unsplash.com/photo-1738618141234-1ee52c6475a7?crop=entropy&cs=srgb&fm=jpg&q=85",
      description: "Combat hunger through food pantries, soup kitchens, and emergency grocery assistance for families in need.",
      details: "Our food programs serve over 1,500 meals annually, providing nutritious options and dignity to those facing food insecurity."
    },
    {
      id: 2,
      title: "Housing Assistance",
      icon: "home",
      image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&q=85",
      description: "Transitional housing for veterans and families, temporary shelter, and resources for achieving stable housing.",
      details: "We provide safe, supportive housing solutions with case management to help individuals transition to independence."
    },
    {
      id: 3,
      title: "Education Programs",
      icon: "book-open",
      image: "https://images.unsplash.com/photo-1588072432836-e10032774350?crop=entropy&cs=srgb&fm=jpg&q=85",
      description: "Daycare, afterschool programs, literacy classes, and tutoring to build brighter futures through education.",
      details: "From early childhood to adult education, we provide learning opportunities that transform lives."
    },
    {
      id: 4,
      title: "Workforce Development",
      icon: "briefcase",
      image: "https://images.pexels.com/photos/3183197/pexels-photo-3183197.jpeg?auto=compress&cs=tinysrgb&w=800",
      description: "Job readiness training, skills development, and placement services to empower economic self-sufficiency.",
      details: "Our workforce programs include resume building, interview prep, and connections with local employers."
    },
    {
      id: 5,
      title: "Counseling",
      icon: "heart",
      image: "https://images.unsplash.com/photo-1758273240360-76b908e7582a?crop=entropy&cs=srgb&fm=jpg&q=85",
      description: "Mental health support, addiction recovery, and wellness programs with compassion.",
      details: "Our licensed counselors provide confidential support grounded in professional expertise."
    },
    {
      id: 6,
      title: "Volunteer Services",
      icon: "hand-helping",
      image: "https://images.unsplash.com/photo-1559027615-cd4628902d4a?crop=entropy&cs=srgb&fm=jpg&q=85",
      description: "Join our community of volunteers making a real difference through service, mentorship, and support.",
      details: "From tutoring to meal preparation, volunteers are the heart of our mission."
    },
    {
      id: 7,
      title: "Faith Outreach",
      icon: "church",
      image: "https://images.unsplash.com/photo-1760367121608-79219f1c9d2a?crop=entropy&cs=srgb&fm=jpg&q=85",
      description: "Bible studies, prayer groups, mentorship, and community events providing spiritual guidance and hope.",
      details: "We welcome all seeking spiritual growth and community connection in a loving environment."
    },
    {
      id: 8,
      title: "Reentry Support",
      icon: "users",
      image: "https://images.unsplash.com/photo-1767047277488-4825112e9ee1?crop=entropy&cs=srgb&fm=jpg&q=85",
      description: "Comprehensive support for successful reintegration including job placement, counseling, and mentorship.",
      details: "We walk alongside individuals returning from incarceration, offering hope and practical support."
    },
    {
      id: 9,
      title: "Liberia Rescue Clinic",
      icon: "heart-pulse",
      image: "https://images.pexels.com/photos/5853836/pexels-photo-5853836.jpeg?auto=compress&cs=tinysrgb&w=800",
      description: "A Liberia, Africa Rescue Clinic for Pregnant Women and Children providing essential healthcare services.",
      details: "Our overseas mission provides critical medical care and support to vulnerable mothers and children in Liberia."
    },
    {
      id: 10,
      title: "Business Investment",
      icon: "trending-up",
      image: "https://images.unsplash.com/photo-1523504754200-45cd634649d7?crop=entropy&cs=srgb&fm=jpg&q=85",
      description: "Investing in businesses and social enterprises that create jobs and strengthen economic development.",
      details: "We support entrepreneurship and business growth that generates sustainable employment opportunities."
    }
  ],

  testimonials: [
    {
      id: 1,
      name: "Sarah M.",
      role: "Program Participant",
      quote: "Gateway Inc. gave me hope when I had none. The housing program helped me get back on my feet, and now I have a stable home for my children.",
      verse: "For I know the plans I have for you, declares the Lord, plans to prosper you and not to harm you, plans to give you hope and a future. - Jeremiah 29:11 NLT"
    },
    {
      id: 2,
      name: "John D.",
      role: "Veteran",
      quote: "After serving my country, I struggled to find my place. The workforce development program helped me discover new skills and find meaningful employment.",
      verse: "The Lord is my strength and my shield; my heart trusts in him, and he helps me. - Psalm 28:7 NLT"
    },
    {
      id: 3,
      name: "Maria L.",
      role: "Single Parent",
      quote: "The childcare and education programs have been a blessing. My kids are thriving, and I can work knowing they're in a loving environment.",
      verse: "Give all your worries and cares to God, for he cares about you. - 1 Peter 5:7 NLT"
    }
  ],

  newsArticles: [
    {
      id: 1,
      title: "Annual Thanksgiving Food Drive Serves 500 Families",
      date: "November 15, 2025",
      excerpt: "Our community came together to provide Thanksgiving meals to over 500 families in need. Thank you to all our volunteers and donors!",
      category: "Community Events"
    },
    {
      id: 2,
      title: "New Workforce Development Partnership Announced",
      date: "October 28, 2025",
      excerpt: "Gateway Inc. partners with local businesses to provide job training and placement for 50 participants this quarter.",
      category: "Programs"
    },
    {
      id: 3,
      title: "Success Story: From Homelessness to Homeownership",
      date: "October 10, 2025",
      excerpt: "Meet the Johnson family, who went from our transitional housing program to owning their first home in just two years.",
      category: "Success Stories"
    }
  ],

  donationLevels: [
    {
      amount: 25,
      impact: "Feeds a family for a week",
      icon: "utensils"
    },
    {
      amount: 50,
      impact: "Provides educational materials for a child",
      icon: "book-open"
    },
    {
      amount: 100,
      impact: "Offers counseling session for someone in crisis",
      icon: "heart"
    },
    {
      amount: 250,
      impact: "Supports job training for one participant",
      icon: "briefcase"
    },
    {
      amount: 500,
      impact: "Provides one month of transitional housing",
      icon: "home"
    }
  ],

  volunteerOpportunities: [
    {
      id: 1,
      title: "Food Market",
      time: "As needed",
      description: "Help organize and distribute food to those in need."
    },
    {
      id: 2,
      title: "Event Coordination",
      time: "As Needed",
      description: "Help plan and execute events."
    },
    {
      id: 3,
      title: "International Hope",
      time: "Varies by Trip",
      description: "Love to travel? Make a lasting impact by connecting and serving in other cultural and geographical settings.",
      note: "There is a volunteer travel cost responsibility."
    }
  ]
};
